import React from "react";

const NotFound = () => {
    return (
        <div className="divFormBlock">
            <div className="Main_Form">
                <h1 className="bigText">404</h1>
                <h1>Page not found!</h1>
            </div>
        </div>
    );
};

export default NotFound;
